/* GLZD — Find Your Glaze quiz logic
   - Reads scent data from the section's <script type="application/json"> block
     (editable in the Shopify theme editor as "Scent" blocks).
   - Questions + scoring weights live below. To retune a match, edit the
     numbers in QUESTIONS. Each weight key must match a Scent block's "Key".
   - Klaviyo: fires onsite events if Klaviyo onsite tracking is active on the
     store. No API keys live in this file — see KLAVIYO note near finish(). */

(function () {
  /* ---- Questions (shared across all instances) ----
     Weight keys (HARBOR, SADDLE, ...) must match the Key field on each
     Scent block. Highest total wins; ties break toward the note picked in Q3. */
  var QUESTIONS = [
    { q: "When you smell good, it should feel like…", opts: [
      { label: "Just out of the shower", sub: "Clean, fresh",    w: { SEAGLASS: 3, BARBER: 1 } },
      { label: "Warm and inviting",      sub: "Draws people in", w: { SADDLE: 3, MIDNIGHT: 2 } },
      { label: "A little unexpected",    sub: "Adventurous",     w: { HARBOR: 3, BARBER: 1 } },
      { label: "Sharp and put-together", sub: "Polished",        w: { BARBER: 3, MIDNIGHT: 1 } }
    ]},
    { q: "Pick the setting you want to own.", opts: [
      { label: "Open air, by the coast", sub: "Daylight",   w: { HARBOR: 2, SEAGLASS: 2 } },
      { label: "Close-up, date night",   sub: "Intimate",   w: { MIDNIGHT: 2, SADDLE: 2 } },
      { label: "Everyday, get it done",  sub: "Daily wear", w: { SEAGLASS: 2, BARBER: 2 } },
      { label: "Out late",               sub: "After dark", w: { MIDNIGHT: 2, HARBOR: 1, SADDLE: 1 } }
    ]},
    { q: "Which note actually pulls you in?", opts: [
      { label: "Salt air & rum",        sub: "Aquatic, spiced", w: { HARBOR: 3 } },
      { label: "Musk & leather",        sub: "Skin, warm",      w: { SADDLE: 3 } },
      { label: "Clean & airy",          sub: "Fresh",           w: { SEAGLASS: 3 } },
      { label: "Citrus & spice",        sub: "Bright, sharp",   w: { BARBER: 3 } },
      { label: "Powder & soft florals", sub: "Smooth",          w: { MIDNIGHT: 3 } }
    ]},
    { q: "How loud do you like it?", opts: [
      { label: "Barely there",         sub: "Just for those who lean in", w: { SEAGLASS: 2, MIDNIGHT: 1 } },
      { label: "Noticed up close",     sub: "Not across the room",        w: { BARBER: 1, HARBOR: 1, SADDLE: 1 } },
      { label: "Leaves an impression", sub: "Stays with them",            w: { SADDLE: 2, HARBOR: 1, MIDNIGHT: 1 } }
    ]},
    { q: "Last one — pick your character.", opts: [
      { label: "The rebel",     sub: "", w: { HARBOR: 2, SADDLE: 1 } },
      { label: "The classic",   sub: "", w: { BARBER: 2, MIDNIGHT: 1 } },
      { label: "The easygoing", sub: "", w: { SEAGLASS: 2 } },
      { label: "The magnetic",  sub: "", w: { SADDLE: 2, MIDNIGHT: 1 } }
    ]}
  ];

  function initQuiz(root) {
    var dataNode = document.getElementById("glzd-scents-" + root.dataset.sectionId);
    if (!dataNode) return;
    var SCENTS = {};
    try {
      JSON.parse(dataNode.textContent).forEach(function (s) {
        s.notesArr = (s.notes || "").split(",").map(function (n) { return n.trim(); }).filter(Boolean);
        SCENTS[s.key] = s;
      });
    } catch (e) { return; }

    var step = 0, answers = [];
    var q = function (sel) { return root.querySelector(sel); };

    function scores() {
      var s = {};
      Object.keys(SCENTS).forEach(function (k) { s[k] = 0; });
      answers.forEach(function (optIdx, qIdx) {
        if (optIdx == null) return;
        var w = QUESTIONS[qIdx].opts[optIdx].w;
        for (var k in w) { if (s[k] != null) s[k] += w[k]; }
      });
      return s;
    }
    function noteFavorite() {
      var a = answers[2];
      if (a == null) return null;
      return Object.keys(QUESTIONS[2].opts[a].w)[0];
    }
    function show(name) {
      root.querySelectorAll(".glzd-screen").forEach(function (sc) { sc.classList.remove("is-active"); });
      q(".glzd-screen[data-screen='" + name + "']").classList.add("is-active");
      root.scrollIntoView({ block: "start", behavior: "instant" });
    }
    function renderQuestion() {
      var Q = QUESTIONS[step];
      q(".glzd-counter").textContent = pad(step + 1) + " / " + pad(QUESTIONS.length);
      q(".glzd-progress span").style.width = ((step + 1) / QUESTIONS.length * 100) + "%";
      q(".glzd-question").textContent = Q.q;
      q(".glzd-back").hidden = step === 0;
      var wrap = q(".glzd-options");
      wrap.innerHTML = "";
      Q.opts.forEach(function (o, i) {
        var b = document.createElement("button");
        b.className = "glzd-opt";
        b.type = "button";
        b.innerHTML = "<span class='glzd-tick'>" + String.fromCharCode(65 + i) + "</span>" +
          "<span>" + o.label + (o.sub ? "<span class='glzd-sub'>" + o.sub + "</span>" : "") + "</span>";
        b.addEventListener("click", function () { choose(i); });
        wrap.appendChild(b);
      });
    }
    function choose(i) {
      answers[step] = i;
      if (step < QUESTIONS.length - 1) { step++; renderQuestion(); }
      else finish();
    }
    function finish() {
      var s = scores();
      var fav = noteFavorite();
      var ranked = Object.keys(SCENTS).sort(function (a, b) {
        if (s[b] !== s[a]) return s[b] - s[a];
        if (a === fav) return -1;
        if (b === fav) return 1;
        return 0;
      });
      var top = SCENTS[ranked[0]], alt = SCENTS[ranked[1]];

      q(".glzd-sku").textContent = top.sku || "";
      q(".glzd-scent-name").textContent = top.name || "";
      q(".glzd-scent-sub").textContent = top.sub || "";
      q(".glzd-why").textContent = top.why || "";
      var link = q(".glzd-card .glzd-btn");
      link.setAttribute("href", top.url || "#");
      q(".glzd-notes").innerHTML = top.notesArr.map(function (n) {
        return "<div class='glzd-note'><span class='glzd-k'>Note</span><span class='glzd-v'>" + n + "</span></div>";
      }).join("");
      q(".glzd-alt").innerHTML = "Also worth a scoop — <a href='" + (alt.url || "#") + "'>" +
        (alt.name || "") + " · " + (alt.sub || "") + "</a>";

      root.classList.add("is-result");
      show("result");

      /* ---- KLAVIYO (everyone who finishes) ----
         Fires only if Klaviyo onsite tracking is loaded on the store.
         Build a Klaviyo flow triggered by the "Viewed Scent Match" metric. */
      if (window.klaviyo) {
        window.klaviyo.push(["track", "Viewed Scent Match", { match: top.name, alt: alt.name }]);
      }
      root._glzdMatch = { match: top.name, alt: alt.name, matchUrl: top.url };
    }

    function pad(n) { return String(n).padStart(2, "0"); }

    /* events */
    q(".glzd-start").addEventListener("click", function () { step = 0; answers = []; renderQuestion(); show("quiz"); });
    q(".glzd-back").addEventListener("click", function () { if (step > 0) { step--; renderQuestion(); } });
    q(".glzd-restart-btn").addEventListener("click", function () { root.classList.remove("is-result"); show("intro"); });
    q(".glzd-send").addEventListener("click", function () {
      var input = q(".glzd-email");
      var v = input.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { input.focus(); input.style.borderColor = "#d8c9a6"; return; }
      var m = root._glzdMatch || {};
      /* ---- KLAVIYO (opted-in email) ----
         identify + a "Completed Scent Quiz" event carrying the match.
         Trigger your match email / list subscribe off this metric in Klaviyo —
         keeps API keys + list IDs OUT of theme code. */
      if (window.klaviyo) {
        window.klaviyo.push(["identify", { "$email": v }]);
        window.klaviyo.push(["track", "Completed Scent Quiz", { "$email": v, match: m.match, alt: m.alt, matchUrl: m.matchUrl }]);
      }
      q(".glzd-cap-row").outerHTML = "<div class='glzd-cap-done'>\u2713 Sent \u2014 check your inbox</div>";
    });

    renderQuestion();
  }

  function boot() { document.querySelectorAll(".glzd-quiz").forEach(initQuiz); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  /* re-init when added/edited in the Shopify theme editor */
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector(".glzd-quiz");
    if (r) initQuiz(r);
  });
})();